<script setup>
import { ref, toRefs } from 'vue'
import Rules from '../components/Rules.vue'
import LaunchersData from '../configs/launcher.json'

var dialog = ref(false)
var model = ref()
var instructionsDialog = ref(false)
var selectedLauncher = ref(null)
var currentStep = ref(1)
var Launchers = ref(LaunchersData)

const props = defineProps({
  home: {
    type: Boolean,
    default: false
  },
  isLoggedIn: {
    type: Boolean,
    default: false
  }
})
const {home} = toRefs(props)

function showInstructions(launcher) {
  selectedLauncher.value = launcher
  currentStep.value = 1
  instructionsDialog.value = true
}

function downloadLauncher(launcher) {
  window.open(launcher.url, '_blank')
}

</script>

<template>

<v-btn size="large" class="play" @click="dialog = true" v-if="home">PLAY NOW !</v-btn>
<div id="menu" @click="dialog = true" v-else>
  <v-icon icon="mdi-download"></v-icon>
<v-tooltip activator="parent" location="right">Download</v-tooltip>
    </div>

  <v-dialog transition="dialog-bottom-transition" :width="500" v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark color="primary">
        <v-icon>mdi-download</v-icon>
        <v-toolbar-title>Download</v-toolbar-title>
        <v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs v-model="model" centered>
            <v-tab value="1">
              Rules
            </v-tab>
            <v-tab value="2">
              requirements
            </v-tab>
            <v-tab value="3">
              Download
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-window v-model="model">
        <v-window-item value="1">
          <v-card>
            <v-card-text>
              <Rules />
            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="2">
          <v-card>
            <v-card-text>
              <v-list lines="one">
                <v-list-item title="Recommended CPU" subtitle="Intel Pentium 4 2.0GHz / AMD Athlon XP 2000+"><template
                    v-slot:prepend>
                    <v-icon icon="mdi-cpu-64-bit"></v-icon>
                  </template></v-list-item>
                <v-list-item title="Recommended GPU" subtitle="DirectX 9 Compatible Graphics Card"><template v-slot:prepend>
                    <v-icon icon="mdi-expansion-card"></v-icon>
                  </template></v-list-item>
                <v-list-item title="Recommended RAM" subtitle="1.5 GB RAM"><template v-slot:prepend>
                    <v-icon icon="mdi-memory"></v-icon>
                  </template></v-list-item>
                <v-list-item title="Recommended storage" subtitle="6 GB HDD or SSD"><template v-slot:prepend>
                    <v-icon icon="mdi-harddisk"></v-icon>
                  </template></v-list-item>
              </v-list>

            </v-card-text>
          </v-card>
        </v-window-item>
        <v-window-item value="3">
          <v-card>
            <v-card-text class="pa-6">
              <v-alert 
                type="info" 
                variant="tonal" 
                class="mb-6"
                icon="mdi-information"
              >
                By downloading the launcher, you accept the rules of the server.
              </v-alert>

              <div class="launchers-container">
                <v-card 
                  v-for="Launcher in Launchers" 
                  :key="Launcher.name"
                  v-show="Launcher?.active"
                  class="launcher-card mb-4"
                  elevation="2"
                  variant="outlined"
                >
                  <v-card-title class="launcher-title">
                    <v-icon class="mr-3" color="primary">mdi-rocket-launch</v-icon>
                    {{ Launcher.name }}
                  </v-card-title>
                  
                  <v-card-text class="pb-2">
                    <p class="text-body-2 text-medium-emphasis mb-4" style="color: white!important">
                      {{ Launcher.description }}
                      Get started with {{ Launcher.name }} - easy installation and setup
                    </p>
                  </v-card-text>

                  <v-card-actions class="launcher-actions px-4 pb-4">
                    <v-btn 
                      variant="elevated" 
                      color="primary"
                      size="large"
                      @click="downloadLauncher(Launcher)" 
                      class="download-btn flex-grow-1 mr-2"
                      prepend-icon="mdi-download"
                    >
                      Download
                    </v-btn>
                    <v-btn 
                      variant="outlined" 
                      color="primary"
                      @click="showInstructions(Launcher)" 
                      class="instructions-btn"
                      icon="mdi-help-circle-outline"
                    >
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>

              <v-divider class="my-6"></v-divider>

              <div class="additional-options">
                <v-card variant="outlined" class="mb-4">
                  <v-card-text class="text-center">
                    <v-icon class="mb-2" size="32" color="success">mdi-linux</v-icon>
                    <div class="text-h6 mb-2">Running on Linux?</div>
                    <v-btn 
                      variant="outlined" 
                      color="success"
                      href="https://lutris.net/games/soapbox-race-world-need-for-speed-world/"
                      target="_blank"
                      prepend-icon="mdi-open-in-new"
                    >
                      Get Lutris Version
                    </v-btn>
                  </v-card-text>
                </v-card>

                <v-card 
                  v-if="isLoggedIn"
                  variant="outlined" 
                  class="premium-card"
                  color="warning"
                >
                  <v-card-text class="text-center">
                    <v-icon class="mb-2" size="32" color="warning">mdi-crown</v-icon>
                    <div class="text-h6 mb-2">Unlock Premium Features</div>
                    <p class="text-body-2 mb-3">Get exclusive benefits and enhanced gameplay</p>
                    <v-btn
                      variant="elevated"
                      color="warning"
                      to="/premium"
                      prepend-icon="mdi-star"
                    >
                      Go Premium
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>

    </v-card>
  </v-dialog>

  <!-- Instructions Dialog -->
  <v-dialog v-model="instructionsDialog" max-width="650" scrollable>
    <v-card v-if="selectedLauncher" class="instructions-dialog" theme="dark">
      <v-toolbar dark color="primary" class="instructions-toolbar">
        <v-icon class="mr-3">mdi-book-open-page-variant</v-icon>
        <v-toolbar-title class="text-h6">{{ selectedLauncher.name }} - Installation Guide</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon variant="text" @click="instructionsDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6 instruction-content">
        <v-alert 
          type="info" 
          variant="outlined" 
          class="mb-6 instruction-alert"
        >
          <v-icon slot="prepend">mdi-information</v-icon>
          Follow these steps to install and set up {{ selectedLauncher.name }}
        </v-alert>

        <div class="instructions-list">
          <div 
            v-for="(instruction, index) in selectedLauncher.instructions" 
            :key="index"
            class="instruction-step mb-4"
            :class="{ 'active-step': currentStep === index + 1 }"
          >
            <div class="step-header d-flex align-center mb-3">
              <v-avatar 
                :color="currentStep >= index + 1 ? 'primary' : 'grey'" 
                size="32" 
                class="mr-3"
              >
                <v-icon v-if="currentStep > index + 1" color="white">mdi-check</v-icon>
                <span v-else class="text-white font-weight-bold">{{ index + 1 }}</span>
              </v-avatar>
              <h4 class="step-title">Step {{ index + 1 }}</h4>
            </div>
            
            <div class="step-content">
              <p class="instruction-text">{{ instruction }}</p>
            </div>
          </div>
        </div>

        <div class="navigation-controls mt-6 d-flex justify-space-between">
          <v-btn 
            v-if="currentStep > 1"
            variant="outlined"
            @click="currentStep = currentStep - 1"
            prepend-icon="mdi-arrow-left"
            class="nav-btn"
          >
            Previous
          </v-btn>
          <v-spacer v-if="currentStep === 1"></v-spacer>
          
          <v-btn 
            v-if="currentStep < selectedLauncher.instructions.length"
            variant="elevated"
            color="primary"
            @click="currentStep = currentStep + 1"
            append-icon="mdi-arrow-right"
            class="nav-btn"
          >
            Next
          </v-btn>
          
          <v-btn 
            v-else
            variant="elevated"
            color="success"
            @click="downloadLauncher(selectedLauncher)"
            prepend-icon="mdi-download"
            class="nav-btn"
          >
            Download Now
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn 
          variant="outlined" 
          @click="instructionsDialog = false"
          prepend-icon="mdi-close"
        >
          Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          variant="elevated" 
          color="success" 
          @click="downloadLauncher(selectedLauncher)"
          prepend-icon="mdi-download"
          size="large"
        >
          Download {{ selectedLauncher.name }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style>
.v-list-item__prepend {
  font-size: 30px!important;
  margin-top: 10px;
}
</style>
<style scoped>
.launchers-container {
  max-width: 100%;
}

.launcher-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.launcher-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.launcher-title {
  font-size: 1.2rem;
  font-weight: 600;
  padding-bottom: 8px;
}

.launcher-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.download-btn {
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
}

.instructions-btn {
  min-width: 48px;
  height: 48px;
}

.additional-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.premium-card {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%);
}

.instructions-dialog .instruction-card {
  background: rgba(66, 66, 66, 0.8) !important;
  border-left: 4px solid rgb(25, 118, 210);
}

.instructions-dialog {
  background: #1e1e1e !important;
}

/* New instruction guide styles */
.instruction-content {
  color: white !important;
}

.instruction-alert {
  background: rgba(33, 150, 243, 0.1) !important;
  border-color: rgba(33, 150, 243, 0.5) !important;
  color: white !important;
}

.instructions-list {
  max-height: 400px;
  overflow-y: auto;
}

.instruction-step {
  padding: 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.instruction-step.active-step {
  background: rgba(25, 118, 210, 0.15);
  border-color: rgb(25, 118, 210);
}

.step-header {
  margin-bottom: 8px;
}

.step-title {
  color: white !important;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.step-content {
  margin-left: 48px;
}

.instruction-text {
  color: rgba(255, 255, 255, 0.9) !important;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}

.navigation-controls {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 16px;
  margin-top: 24px;
}

.nav-btn {
  min-width: 120px;
}

.instruction-text {
  white-space: normal !important;
  word-wrap: break-word;
  line-height: 1.6;
  font-size: 1rem;
}

.step-navigation {
  margin-top: 24px;
}

.instructions-toolbar {
  border-radius: 4px 4px 0 0;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .launcher-actions {
    flex-direction: column;
    align-items: stretch;
  }
  
  .download-btn {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .instructions-btn {
    width: 100%;
    min-width: unset;
    height: auto;
    padding: 12px;
  }
  
  .step-navigation {
    flex-direction: column;
    gap: 12px;
  }
}

button {
  margin: initial !important;
}

#menu {
    font-weight: bold;
    color: white;
    text-decoration: none;
    border-radius: 6px;
    margin-bottom: 10px;
    height: 40px;
    width: 40px;
    background: transparent;
    transition: all 0.15s ease-in-out;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    cursor: pointer;
}

#menu i {
    margin: 0 7px;
}

.play {
    margin-bottom: 20px!important;
    background: var(--tertiary-color);
    margin-top: 30px;
}

.router-link-active {
    font-weight: bold;
    border-left: 2px solid white;
    background: var(--tertiary-color) !important;
    color: white;
    vertical-align: middle;
}

#menu:hover {
    font-weight: bold;
    background: var(--quaternary-color);
    color: white;
    vertical-align: middle;
}
</style>

<style>
.v-list-item-title {
  margin: 10px 0 !important;
}
</style>